<template>
  <div class="extension_time">
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">ขอขยายเวลาที่ยื่นเสนอ สป.อว</div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
                clearable
                :items="status"
                @onChange="searchData.status = $event; getData()"
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-icon="ic:baseline-search"
              @onChange="searchData.keyword = $event"
              @onEnter="getData()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <v-layout class="d-flex align-center mb-6">
      <v-flex shrink mr-3>
        <v-img
          :src="
            require('../../../../assets/images/extension-time/calendar-add.png')
          "
          width="20"
          height="20"
        ></v-img>
      </v-flex>
      <v-flex shrink>
        <div class="font-20 font-w-600">
          รายการยื่นขอขยายเวลาที่ส่งยื่นให้ สป.อว
        </div>
      </v-flex>
    </v-layout>

    <div class="d-flex justify-space-between table-head">
      <div
        v-for="(item, i) in tableHeader"
        :key="i"
        :style="{ width: item.width, textAlign: item.align }"
      >
        {{ item.name }}
      </div>
    </div>

    <div class="list-layout">
      <RSPExtendTimeItem
        v-for="(item, i) in items"
        :key="i"
        :index="i"
        :item="item"
        :headers="tableHeader"
        @onDelete="onDelete"
        @onSendExtendTime="onSendExtendTime"
      ></RSPExtendTimeItem>
    </div>

    <v-pagination
      class="mt-6"
      v-model="paginate.current_page"
      :length="paginate.last_page"
      color="#DE7033"
      @input="getData"
    ></v-pagination>

    <!-- <pre>
      {{ items }}
    </pre> -->
  </div>
</template>

<script>
import TextField from "../../../../components/input/TextField";
import SelectBox from "../../../../components/input/SelectBox";
import { mapState } from "vuex";
import Service from "../../../../services";
import RowCard from "../../../../components/RowCard.vue";
import moment from "moment";
import RSPExtendTimeItem from "../../../../components/RSPExtendTimeItem.vue";

export default {
  name: "ConsiderFormList",
  components: {
    TextField,
    SelectBox,
    RowCard,
    RSPExtendTimeItem,
  },
  data() {
    return {
      theme: 2,
      panel: [],
      tableHeader: [
        {
          name: "",
          width: "5%",
          align: "center",
        },
        {
          name: "ลำดับ",
          width: "5%",
          align: "center",
        },
        {
          name: "ปี งปม.",
          width: "10%",
          align: "center",
        },
        {
          name: "ชื่อโครงการหลัก",
          width: "34%",
          align: "start",
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '10%'
        },
        {
          name: 'วัน-เวลาที่สร้าง',
          width: '13%'
        },
        {
          name: "สถานะ",
          width: "8%",
          align: "center",
        },
        {
          name: "",
          width: "15%",
          align: "center",
        },
      ],
      items: [],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
      status: [
          'Draft',
          'Submitted',
          'Approved',
      ],
      searchData: {
        status: null,
        keyword: null
      },
    };
  },
  created() {
    this.getData(1);
  },
  methods: {
    async getData(page) {
      console.log(page);
      let payload = {
        page: page,
        status: this.searchData.status ?? this.status.join(','),
        keyword: this.searchData.keyword
      };

      let res = await this.$apiFire("RSPExtend/index", payload);

      if (res) {
        this.paginate = {
          total: res.total,
          per_page: res.per_page,
          current_page: res.current_page,
          last_page: res.last_page,
        };
        this.items = res.data;
      }
      this.$forceUpdate() 
    },
    async onSendExtendTime(id) {
      console.log("onSendExtendTime", id);
      let res = await this.$apiFire("Extend/extendRequestRSP", {
        pending_group_id: id,
      });

      if (res) {
        window.location.reload();
      }
    },
    onDelete(id) {
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("RSPExtend/delete",id);
          if (res) {
            this.getData(1);
            // this.$store.commit("General/setModal", {
            //   title: "เสร็จสิ้น!",
            //   theme: "success",
            //   text: res,
            //   showCancel: false,
            // });
          }
        },
      });
    },
  },
};
</script>

<style lang="scss">
.extension_time {
  .table-head {
    padding: 0 33px 0 36px;
    margin-bottom: 12px;
    // gap: 8px;
  }

  .list-layout {
    // padding: 0 33px 0 36px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .btn-create-consider {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    height: 30px;
    padding: 0px 10px;
  }
  .row_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    height: 73px;
  }
  .div_status {
    background: #b1b1b1;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px 0px 0px 20px;
    width: 19px;
    height: 73px;
  }
  .v-expansion-panel-header {
    padding: 0px !important;
  }
  .v-expansion-panel::before {
    border-radius: 20px !important;
    box-shadow: unset !important;
  }
  .v-expansion-panel:not(:first-child)::after {
    border: unset !important;
  }
  .theme--light.v-expansion-panels .v-expansion-panel {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.87);
  }
  .v-expansion-panels:not(.v-expansion-panels--accordion):not(
      .v-expansion-panels--tile
    )
    > .v-expansion-panel--next-active
    .v-expansion-panel-header {
    border-bottom-left-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
  }
  .v-expansion-panel--active:not(:first-child),
  .v-expansion-panel--active + .v-expansion-panel {
    margin-top: 0px !important;
  }
  .custom__expansion_panel_content {
    background: #fafafa;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 20px 20px;
  }
  .v-expansion-panel-content__wrap {
    padding: 0 18px !important;
  }
  .theme--light.v-expansion-panels
    .v-expansion-panel-header
    .v-expansion-panel-header__icon
    .v-icon {
    color: rgba(0, 0, 0, 0.54);
    font-size: 36px;
  }
}
</style>
